import React, { useEffect, useRef, useState } from "react";

import Footer from "../CommonComponents/Footer";
import { useStore } from "../../store";
import CustomList from "../CommonComponents/CustomList";
import BackHeader from "../CommonComponents/BackHeader";
import api from "../../api/apiClient";
import { endpoints } from "../../api/endpoints";
import {
  AlbumType,
  ArtistType,
  DataType,
  SongType,
  storeType,
} from "../../types";
import { useLocation } from "react-router-dom";
import { useRouteTracker } from "./RouteTracker";

export default function SongListsBySpecficId() {
  const { store, updateStoreFunc } = useStore();

  const { scrollPos, page, hasMore, loading, data, searchQuery, dataApi } =
    store.songListsBySpecificId;

  const firstMounted = useRef(true);

  const location = useLocation();
  const type: string = location.state?.selectedTag;
  const headerData = location.state?.headerData;

  const fetchData = async () => {
    const tag = type?.toLowerCase();
    if (page === 1) updateStoreFunc("songListsBySpecificId", "loading", true);
    let p = 1;
    if (searchQuery) {
      p = 1;
    } else {
      p = page;
    }
    const filter = {
      artistId:
        tag === "artist" || type === "Male" || type === "Female"
          ? (headerData as ArtistType).artist_id
          : null,
      composerId:
        tag === "composer" ? (headerData as ArtistType).artist_id : null,
      albumId: (headerData as AlbumType).id,
    };
    const stringifiedFilter = JSON.stringify(filter);
    const result: any = await api.get(
      endpoints.common.search +
        `?keyword=${searchQuery}&current=${p}&limit=10&type=${"title"}&filter=${stringifiedFilter}`
    );

    updateStoreFunc(
      "songListsBySpecificId",
      "dataApi",
      endpoints.common.search +
        `?keyword=${searchQuery}&current=${
          p + 1
        }&limit=30&type=${"title"}&filter=${stringifiedFilter}`
    );

    if (p === 1) updateStoreFunc("songListsBySpecificId", "loading", false);

    if (result.code === "200") {
      updateStoreFunc(null, null, null, (pre: storeType["store"]) => {
        const d: DataType = result.data;
        let arr: any;
        let o = { ...pre };
        let a: any = { ...o.songListsBySpecificId.data };
        if (p > 1) {
          arr = [...a?.by, ...d!.by];
          a.by = arr;
          o.songListsBySpecificId.data = a;
          return o;
        } else {
          a = d;
          o.songListsBySpecificId.data = a;
          return o;
        }
      });
    } else {
      if (p > 1) {
        updateStoreFunc("songListsBySpecificId", "hasMore", false);
      } else {
        updateStoreFunc("songListsBySpecificId", "hasMore", false);
        updateStoreFunc("songListsBySpecificId", "data", null);
      }
    }
  };

  const handleFetchMore = () => {
    updateStoreFunc("songListsBySpecificId", "page", page + 1);
  };

  const handleSearchChange = (v: string) => {
    updateStoreFunc("songListsBySpecificId", "searchQuery", v);
  };

  const handleScroll = (event: any) => {
    const scrollTop = event.target.scrollTop;
    updateStoreFunc("songListsBySpecificId", "scrollPos", scrollTop);
  };

  useEffect(() => {
    if (firstMounted.current && data) return;
    if (searchQuery === "") {
      updateStoreFunc("songListsBySpecificId", "hasMore", true);
    }
    fetchData();
  }, [searchQuery, page]);

  useEffect(() => {
    if (firstMounted.current) return;
    updateStoreFunc("songListsBySpecificId", "page", 1);
  }, [searchQuery]);

  useEffect(() => {
    if (firstMounted.current) return;
    if (data?.by?.length === data?.pagination?.total) {
      updateStoreFunc("songListsBySpecificId", "hasMore", false);
    }
  }, [data]);

  useEffect(() => {
    if (firstMounted.current) firstMounted.current = false;
    return () => {
      if (window.location.pathname !== "/songDetail") {
        updateStoreFunc("songListsBySpecificId", "data", null);
        updateStoreFunc("songListsBySpecificId", "hasMore", true);
        updateStoreFunc("songListsBySpecificId", "page", 1);
        updateStoreFunc("songListsBySpecificId", "searchQuery", "");
      }
    };
  }, []);

  return (
    <div>
      <BackHeader />
      <div style={{ padding: "0 15px" }}>
        <CustomList
          data={data}
          searchQuery={searchQuery}
          type={"Song"}
          onSearchChange={handleSearchChange}
          showFavorite
          showSearchBar
          loading={loading}
          handleFetchMore={handleFetchMore}
          hasMore={hasMore}
          scrollHeight={
            type === "Album"
              ? store.screenHeight - 240
              : store.screenHeight - 210
          }
          artistHeader={
            type === "Artist" ||
            type === "Composer" ||
            type === "Male" ||
            type === "Female"
              ? true
              : false
          }
          artistHeaderData={headerData}
          albumHeader={type === "Album" ? true : false}
          albumHeaderData={headerData}
          dataApi={dataApi}
          handleScroll={handleScroll}
          scrollPos={scrollPos}
        />
      </div>
      <Footer />
    </div>
  );
}
